import adminHttp from '/src/api/adminHttp'

export default {
    getTeams: (tournamentId, params) => adminHttp.get(`/api/v1/admin/tournament/teams/${ tournamentId }`,{
        ...(params && { params }),
    }),
    getTeam: (teamId, tournamentId) => adminHttp.get(`/api/v1/admin/tournament/team/${ teamId }/${ tournamentId }`),
    getStages: (tournamentId) => adminHttp.get(`/api/v1/admin/tournament/stage-list/${ tournamentId }`),
    getGroups: (stageId) => adminHttp.get(`/api/v1/admin/tournament/group-list/${ stageId }`)
}